var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Loader"},[_c('div',[_c('v-progress-circular',{attrs:{"size":150,"width":3,"color":"primary","indeterminate":""}}),_c('p',{staticClass:"text-center py-4"},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }